import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/ClinicalOperations`;

/**
 * Obtiene las observaciones clínicas de un paciente.
 *
 * Las observaciones con status `deleted` (25) son excluidas automáticamente por el SP.
 * Resultados ordenados por fecha de creación descendente (más recientes primero).
 *
 * @param {string} cipId - CIP ID del paciente
 *
 * Ejemplo de llamada:
 * GET /api/ClinicalOperations/observations-v2/{cipId}
 *
 * Respuesta exitosa (200):
 * [
 *   {
 *     "observationId": 157,
 *     "cipId": "12345",
 *     "message": "Patient requires follow-up after discharge",
 *     "componentId": 1,
 *     "componentName": "Test Component",
 *     "priority": null,
 *     "employeeId": 42,
 *     "employeeName": "Maria Garcia",
 *     "status": 23,
 *     "statusName": "Open",
 *     "createdAt": "2026-04-08T14:30:00",
 *     "updatedAt": null
 *   }
 * ]
 *
 * Respuesta sin observaciones (200): []
 */
const getObservationsByPatient = async (cipId) => {
  try {
    const response = await axios.get(`${API_URL}/observations-v2/${cipId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching observations:", error);
    throw error;
  }
};

export default getObservationsByPatient;
